import { ForgotPasswordRequest } from "../request/ForgotPasswordRequest";
import { NetworkResponse } from "./.././.././.././../service/NetworkResponse";
import { ForgotPasswordResponse } from "../response/ForgotPasswordResponse";
import ForgotPasswordClient from "./ForgotPasswordApiClient";
import HttpService from ".././.././.././../service/HttpService"; // Adjust the import as necessary
import Loader from "./../../../../utils/Utils";
import { useAlert } from "../../../../components/AlertContextComponent";
import { AlertProps } from "reactstrap";

export const forgotPasswordEmail = async (
  api: HttpService,
  email: string,
  showAlert: (props: Partial<AlertProps>) => void,
) => {
  const param: ForgotPasswordRequest = {
    email_address: email,
    entity_type: "USER",
  };

  try {
    Loader.showLoading("Loading...");
    const response = await api
      .post<
        NetworkResponse<ForgotPasswordResponse>
      >(ForgotPasswordClient.forgotUrl, param)
      .then((response) => {
        if (response.data.detail != null) {
          showAlert({
            show: true,
            title: "Success",
            message: response.data.detail,
            alertType: "success",
            onlyNeedOneButton: true,
            button1Text: "OK",
          });
          return response.data;
        } else {
          showAlert({
            show: true,
            title: "Error",
            message: response.data.error,
            alertType: "error",
            onlyNeedOneButton: true,
            button1Text: "OK",
          });
        }
      });
  } catch (error) {
    throw error;
  } finally {
    Loader.dismissLoading();
  }
};
